<template>
    <div class="dev-list">
        <div class="device-case-dev border-all">
            <el-table ref="multipleTable" :height="tableHeight" :data="info.list"
                      :header-cell-style="{backgroundColor: '#efefef'}" size="mini" tooltip-effect="dark"
                      style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center" header-align="center"></el-table-column>
                <el-table-column prop="groupName" label="分组名称"></el-table-column>
                <el-table-column label="组内设备数量">
                    <template slot-scope="scope">
                        {{scope.row.deviceNum || 0}}
                    </template>
                </el-table-column>
                <el-table-column prop="appNum" label="组内应用数量"></el-table-column>
            </el-table>
            <div class="list-bottom">
                <div class="list-bottom-btn">
                    <el-button size="default"  @click="appGroupMerge" v-if="$store.getters.checkChangeAuth()" type="primary">关联分组
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AppListGroup",
        data() {
            return {
                tableHeight: 0,
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                multipleSelection: [] // 选中的对象列表
            }
        },
        computed: {},
        methods: {
            /* 获取分组列表 */
            async getGroupList() {
                let that = this
                that.info = await that.$post(that.$uri.group.list, {})
            },
            /* 获取该应用关联的分组 */
            async getAppGroup(appId) {
                let that = this
                let res = await that.$post(that.$uri.group.list, {appId})
                return res.list
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            /* 初始化 */
            async init() {
                this.getGroupList()
                let list = await this.getAppGroup(this.$store.state.appInfo.appId)
                if (list) {
                    list.forEach(v => {
                        this.info.list.forEach(i => {
                            if (v.id === i.id) {
                                this.$refs.multipleTable.toggleRowSelection(i)
                            }
                        })
                    })
                }
            },
            /* 应用关联分组 */
            appGroupMerge() {
                let list = []
                this.multipleSelection.forEach(v => {
                    list.push(v.id)
                })
                let that = this
                that.$post(that.$uri.apk.apkGroupMerge, {
                    appId: that.$store.state.appInfo.appId,
                    groupIds: list
                }).then(res => {
                    that.$message.success("关联分组成功")
                    that.init()
                })
            }
        },
        mounted() {
            this.init()
            this.$nextTick().then(() => {
                if (this.$refs.multipleTable) {
                    this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                }
            })
        }
    };
</script>

<style lang="less" scoped>
    .dev-list {
        .dev-list-search {
            width: 100%;
            display: flex;
            flex-direction: column;
            .search-btn {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .search-advanced {
                display: flex;
                flex-direction: column;
                .search-main {
                    margin-top: 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .search-main-item {
                        width: 24%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        /*flex-grow: 1;*/
                        padding: 5px 10px;
                        span {
                            font-size: 12px;
                        }
                        .item-input {
                            width: 180px;
                        }
                    }
                }
                .search-btn {
                    padding: 0 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: center;
                }
            }
        }
        .device-case-dev {
            margin-top: 10px;
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                .list-bottom-btn {
                    margin-right: 30px;
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }
</style>